var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import "../../../const/iconLibrary";
import { colors } from "syf-component-library/defaultTheme";
import { Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import MessageBoxWrapper from "./subcomponents";
var MessageBox = function (_a) {
    var title = _a.title, description = _a.description, icon = _a.icon, type = _a.type, color = _a.color, closeHandler = _a.closeHandler;
    var t = useTranslation().t;
    return (_jsxs(MessageBoxWrapper, __assign({ type: type, role: "alertdialog", color: color, closeHandler: closeHandler, closeIconColor: colors.black, icon: icon, closeButtonAriaLabel: "Dismiss Message" }, { children: [title && (_jsxs(_Fragment, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: t(title) })), _jsx(Stack, { size: "small" })] })), _jsx(Body, { children: t(description) })] })));
};
export default MessageBox;
